import React from 'react';
import { FileSpreadsheet } from 'lucide-react';

const fmtDate = (iso) => iso ? new Date(iso).toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '';

function Chips({ label, items, testid }) {
  if (!items?.length) return null;
  return (
    <div data-testid={testid}>
      <p className="text-[9px] uppercase tracking-widest font-bold text-muted-foreground mb-1">{label}</p>
      <div className="flex flex-wrap gap-1">{items.map((x, i) => <span key={i} className="text-[10px] border border-border rounded-sm px-1.5 py-px text-foreground/80">{x}</span>)}</div>
    </div>
  );
}

export function WorkbookFacts({ wb }) {
  if (!wb) return null;
  const buy = wb.vehicles.filter(v => v.side === 'acquisition');
  const sell = wb.vehicles.filter(v => v.side === 'disposal');
  return (
    <div className="bg-card border border-border rounded-sm px-4 py-3 space-y-3" data-testid="wb-facts">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <p className="text-[10px] uppercase tracking-widest font-bold text-emerald-300/80 inline-flex items-center gap-1.5"><FileSpreadsheet className="w-3 h-3" /> Aus „Deals by Firm“-Workbook</p>
        <span className="text-[10px] text-muted-foreground/70 truncate max-w-[360px]">{wb.file}{wb.imported_at ? ` · ${fmtDate(wb.imported_at)}` : ''}</span>
      </div>
      <div className="flex items-center gap-4 flex-wrap text-[11px]">
        <span className="font-mono text-emerald-300" data-testid="wb-facts-acq">{wb.acquisitions} Käufe</span>
        <span className="font-mono text-amber-300" data-testid="wb-facts-disp">{wb.disposals} Verkäufe</span>
        <span className="text-muted-foreground">{wb.vehicles.length} Fonds-Vehikel</span>
      </div>
      <div className="grid sm:grid-cols-3 gap-3">
        <Chips label="Sektoren" items={wb.sectors} testid="wb-facts-sectors" />
        <Chips label="Länder" items={wb.countries} testid="wb-facts-countries" />
        <Chips label="Regionen" items={wb.regions} testid="wb-facts-regions" />
      </div>
      {wb.vehicles.length > 0 && (
        <div className="grid lg:grid-cols-2 gap-3 text-[11px]">
          {[['Kaufende Vehikel', buy, 'wb-facts-buy'], ['Verkaufende Vehikel', sell, 'wb-facts-sell']].map(([label, list, tid]) => list.length > 0 && (
            <div key={tid} data-testid={tid}>
              <p className="text-[9px] uppercase tracking-widest font-bold text-muted-foreground mb-1">{label}</p>
              <div className="divide-y divide-border/40 border border-border rounded-sm max-h-48 overflow-auto">
                {list.map((v, i) => (
                  <div key={i} className="flex items-center justify-between gap-2 px-2 py-1"><span className="truncate">{v.name.replace(/\|\|/g, ' + ')}</span><span className="font-mono text-muted-foreground shrink-0">{v.deals} Deals</span></div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
